import { registerDestructor } from "@ember/destroyable";
import { action } from "@ember/object";
import Component from "@glimmer/component";

export default class SetupPredictorTooltipComponent extends Component {
  constructor(owner, args) {
    super(owner, args);

    window.ShowTooltip = this.showPredictorTooltip;
    window.HideTooltip = this.hidePredictorTooltip;

    registerDestructor(this, () => {
      delete window.ShowTooltip;
      delete window.HideTooltip;
    });
  }

  private;

  setPredictorTooltip(
    obj: HTMLElement,
    visibility: "visible" | "hidden"
  ): void {
    const cur = obj.id.split("_")[1];
    const tip = document.getElementById("tooltip-content_" + cur);
    tip?.setAttribute("visibility", visibility);
  }

  @action
  showPredictorTooltip(obj: HTMLElement): void {
    this.setPredictorTooltip(obj, "visible");
  }

  @action
  hidePredictorTooltip(obj: HTMLElement): void {
    this.setPredictorTooltip(obj, "hidden");
  }
}
